import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

export function InitialDateFormItem(): JSX.Element {
	return (
		<FormItemWrapper name="initial_date" label={I18n.get('Initial date')} labelCol={{ span: 24 }}>
			<S.DatePickerWrapper
				format="L"
				placeholder={I18n.get('Initial date')}
				disabledDate={(currentDate) => currentDate && currentDate.valueOf() > Date.now()}
			/>
		</FormItemWrapper>
	);
}
